import React, { Fragment } from 'react'
import styled, { ThemeProvider } from 'styled-components'
import 'whatwg-fetch'
import * as vars from '../style/vars'
import { maxHeight, below } from '../style/functions'
import Input from './input'
import { colors } from '../style/vars'
import circleArrow from '../svg/right-circle-white.svg'
import download from '../svg/download.svg'

class RegisterForm extends React.Component {
   constructor() {
      super()
      let url
      if (typeof window !== `undefined`) {
         url = window.location.href
            .replace('https://', '')
            .replace('http://', '')
            .replace(/\/$/, '')
      } else {
         url = ''
      }
      this.state = {
         formStatus: 'incomplete',
         values: {},
         url: url
      }
      this.brochureModal = React.createRef()
      this.getBrochure = React.createRef()
   }

   updateForm = e => {
      let values = this.state.values
      if (e.target.getAttribute('name') !== 'Postcode') {
         values[e.target.getAttribute('name')] = e.target.value
         this.setState({ values })
      } else {
         return false
      }
   }

   componentDidMount() {
      this.updateForm = this.updateForm.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
      this.openModal()
   }

   handleSubmit(e) {
      e.preventDefault()

      const submitBtn = document.getElementById('submit')
      submitBtn.style.cursor = 'progress'
      submitBtn.disabled = true
      submitBtn.innerHTML = 'LOADING'

      const fields = [].slice.call(e.target.querySelectorAll('[name]'))
      fields.map(f => {
         let values = this.state.values
         values[f.getAttribute('name')] = f.value
      })

      var values = this.state.values

      values['comment'] = `Booking Requested
                           ${values.Prefered_Date}
                           ${values.Prefered_Time}
                          `
      let formStatus = 'complete'
      this.setState({ formStatus })

      setTimeout(() => {
         this.getBrochure.current.click()
      }, 1000);

      // fetch(
      //    'https://vds9c5imf1.execute-api.ap-southeast-2.amazonaws.com/prod/yarrabend',
      //    {
      //       method: 'POST',
      //       headers: { 'Content-Type': 'application/json' },
      //       body: JSON.stringify(values)
      //    }
      // )
      //    .then(res => res.json())
      //    .then(json => {
      //       if (json.errorMessage) {
      //          alert('Error submitting request please call +61 (0)3 9573 8320')
      //       } else {
      //          let formStatus = 'complete'
      //          this.setState({ formStatus })
      //       }
      //    })
      //    .catch(err => console.log(err))
   }

   openModal = () => {
      setTimeout(() => {
         this.brochureModal.current.style.zIndex = 1000
         this.brochureModal.current.style.opacity = 1
      }, 7000)
   }

   closeModal = () => {
      this.brochureModal.current.style.opacity = 0
      setTimeout(() => {
         this.brochureModal.current.style.zIndex = -1
      }, 1000)
   }

   render() {
      let styledLocation = this.props.location
         .replace(/-/g, ' ')
         .split(' ')
         .map(s => s.charAt(0).toUpperCase() + s.substring(1))
         .join(' ')
      return (
         <Container
            onClick={this.closeModal}
            popup={this.props.popup}
            shown={this.props.shown}
            className="brochure-modal"
            innerRef={this.brochureModal}>
            <Close className="close" />
            {this.state.formStatus === 'complete' ? (
               <Form onClick={event => event.stopPropagation()}>
                  <h2>THANK YOU FOR REGISTERING.</h2>
                  <ThankYouText className={'form__thankyou'}>
                     Download will begin automatically.
                  </ThankYouText>
                  <DownloadLink href={`/${this.props.location}-brochure.pdf`}
                     download
                     innerRef={this.getBrochure}>
                     Download
                  </DownloadLink>
               </Form>
            ) : (
                  <Fragment>
                     <Form
                        action=""
                        onSubmit={this.handleSubmit}
                        onClick={event => event.stopPropagation()}>
                        <h2>Register now to download {styledLocation} brochure.</h2>
                        <Field>
                           <Input
                              name="first_name"
                              label="First Name"
                              required
                              onChange={this.updateForm}
                           />
                        </Field>
                        <Field>
                           <Input
                              name="last_name"
                              label="Surname"
                              required
                              onChange={this.updateForm}
                           />
                        </Field>
                        <Field>
                           <Input
                              name="phone"
                              label="Phone Number"
                              required
                              onChange={this.updateForm}
                           />
                        </Field>
                        <Field>
                           <Input
                              name="suburb"
                              label="Suburb"
                              required
                              onChange={this.updateForm}
                           />
                        </Field>
                        <Field>
                           <Input
                              name="email"
                              label="Email address"
                              required
                              onChange={this.updateForm}
                           />
                        </Field>
                        {/* <Field>
                        <Input
                           name="tags"
                           type="select"
                           label="Home Type"
                           onChange={this.updateForm}
                           required
                           options={[
                              { value: 'All', label: 'All' },
                              { value: 'Lofts', label: 'Lofts' },
                              { value: 'Apartments', label: 'Apartments' },
                              { value: 'House and land', label: 'House & Land' },
                              { value: 'Townhouse', label: 'Townhouse' }
                           ]}
                        />
                     </Field> */}
                        {/* <Field>
                        <Input
                           name="Prefered_Date"
                           type="select"
                           label="Prefered Date"
                           onChange={this.updateForm}
                           required
                           options={[
                              { value: 'mon', label: 'Monday' },
                              { value: 'tue', label: 'Tuesday' },
                              { value: 'wed', label: 'Wednesday' },
                              { value: 'thu', label: 'Thursday' },
                              { value: 'fri', label: 'Friday' },
                              { value: 'sat', label: 'Saturday' },
                              { value: 'sun', label: 'Sunday' }
                           ]}
                        />
                     </Field> */}
                        {/* <Field>
                        <Input
                           name="Prefered_Time"
                           type="select"
                           label="Prefered Time"
                           onChange={this.updateForm}
                           required
                           options={[
                              { value: 'Morning', label: 'Morning' },
                              { value: 'Afternoon', label: 'Afternoon' },
                              { value: 'Evening', label: 'Evening' }
                           ]}
                        />
                     </Field> */}

                        {this.props.square ? (
                           <button id="submit" className="btn btn-square">
                              <span>Register</span>
                           </button>
                        ) : (
                              <Submit id="submit" square={this.props.square}>
                                 Register
                        </Submit>
                           )}
                     </Form>
                  </Fragment>
               )}
         </Container>
      )
   }
}

export default RegisterForm

const Container = styled.div`
   position: fixed;
   top: 0;
   bottom: 0;
   left: 0;
   right: 0;
   background: rgba(63, 62, 62, 0.9);
   opacity: 0;
   transition: opacity 0.3s ease-in-out;
   z-index: -1;
`

const Close = styled.div`
  height: 4rem;
  width: 4rem;
  position: absolute;
  top: 3rem;
  right: 3rem;
  color: ${colors.blank};
  cursor: pointer;
	transition: color ${vars.time};

  &:after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: currentColor;
    position: absolute;
    top: 50%;
    left: 0;
    transform: rotate(45deg);
  }
  &:before {
    content '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: currentColor;
    position: absolute;
    top: 50%;
    left: 0;
    transform: rotate(-45deg);
  }
	&:hover{
		color: rgba(256, 256, 256, .7);
	}
   ${below.tablet`
      top: 1rem;
      right: 1rem;
	`}
`

const Form = styled.form`
   position: absolute;
   transform: translate(-50%, -50%);
   top: 50%;
   left: 50%;
   /* border: 1px solid lime; */
   color: ${colors.blank};
   padding: 2vw;
   width: 75%;
   max-width: 90rem;
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
   justify-content: space-between;
   .btn {
      margin: ${vars.padding.inner}rem auto auto auto;
      flex-basis: 53%;
   }

   h2 {
      text-align: center;
      padding-bottom: 6rem;
   }
   ${below.tablet`
		max-width: 100%;
		width: 100%;
	`} ${below.mobile`
      display:block;
  `};
`

const Field = styled.div`
   font-size: 2rem;
   border-bottom: 1px solid ${colors.inactiveColor};
   width: calc(50% - 1rem);
   display: inline-block;
   margin-bottom: 0rem;
   @supports (display: flex) {
      display: block;
   }

   ${below.mobile`
		width: 100%;
		margin-left: auto;
		margin-right: auto;
      display:block;
      margin-bottom: 0;
	`};
`

const Submit = styled.button`
   position: relative;
   flex-basis: 100%;
   text-align: left;
   font-size: 1.4rem;
   background: transparent;
   color: ${colors.blank};
   text-decoration: underline;
   cursor: pointer;
   margin-top: ${vars.padding.inner / 2}rem;
   transition: margin-left 0.3s;
   &:hover {
      margin-left: 1rem;
   }
   &:before {
      content: '';
      display: inline-block;
      width: 3rem;
      height: 3rem;
      background: url(${circleArrow});
      vertical-align: middle;
      margin-right: ${vars.padding.mobOuter * 2}px;
   }
`

const DownloadLink = styled.a`
   color: white;
   font-size: 2rem;
   display: block;
   text-align: center;
   width: 100%;
   text-decoration: none;
   &:hover {
      opacity: .7;
   }

   &:before {
      content: '';
      display: inline-block;
      vertical-align: baseline;
      width: 2rem;
      height: 2rem;
      margin-right: 1rem;
      background: url(${download})
   }
`

const ThankYouText = styled.p`
   text-align: center;
   width: 100%;
`



// WEBPACK FOOTER //
// ./src/components/brochureModal.js